<template>
  <div>
    <CountryFlag
      v-if="countryIsoCode && showCountryFlag"
      :iso="countryIsoCode"
      mode="squared"
    ></CountryFlag>
    <span v-if="showCountryName">{{ countryName }}</span>
  </div>
</template>

<script>
import CountryFlag from '@dzangolab/vue-country-flag-icon'
import '@dzangolab/vue-country-flag-icon/dist/CountryFlag.css' // import stylesheet

export default {
  components: {
    CountryFlag
  },

  props: {
    countryName: {
      type: String,
      required: true
    },
    countryIsoCode: {
      type: String
    },
    showCountryName: {
      type: Boolean,
      default: true
    },
    showCountryFlag: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style></style>
